import { render, staticRenderFns } from "./create-document.vue?vue&type=template&id=3fafebe3&scoped=true"
import script from "./create-document.vue?vue&type=script&lang=js"
export * from "./create-document.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fafebe3",
  null
  
)

export default component.exports